import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModalRef, NgbModal, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatApiService } from 'src/app/core/services/api/chat-api.service';
import { UsersApiService } from 'src/app/core/services/api/users-api.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ChatService } from 'src/app/core/services/chat.service';
import { Chat } from 'src/app/shared/models/chat/chat';
import { Message } from 'src/app/shared/models/chat/message';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';
import { User } from 'src/app/shared/models/users/user';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-chat-content',
  templateUrl: './chat-content.component.html',
  styleUrls: ['./chat-content.component.scss']
})
export class ChatContentComponent implements OnInit, OnDestroy, AfterViewChecked {

  public messages: Message[] = [];
  public resultData = [];

  private uuid: string = null;
  public activeChat: Chat = new Chat();
  updatedChat: Chat;
  destroyed$ = new Subject();
  isMessageArabic = false;
  messagetxt = '';
  user = null;
  page = 0;
  userNgSelect = null;
  isTyping = false;
  isOtherTyping = false;
  updatedChatName: string;
  addedChatMembers: User[];

  timeout: any;
  chatHeight: number;

  isMembersListUpdated = false;

  @ViewChild('groupInfoModal') groupInfoModal;
  groupInfoModalRef: NgbModalRef;

  @ViewChild('chatWrapper') chatWrapper: ElementRef<HTMLElement>;
  datePipe = new DatePipe('en-US');

  constructor(
    private chatApi: ChatApiService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private chatService: ChatService,
    private toastr: ToastrService,
    private userApi: UsersApiService
  ) {
    this.user = this.authService.user;
  }
  ngOnInit(): void {
    this.userNgSelect = new NgSelectProps(this.userApi.getStaffUsers);
    this.route.params.subscribe(params => {
      this.chatApi.CloseConnection();
      this.messages = [];
      this.uuid = params.uuid;
      this.listenToChat();
      this.chatApi.fetchMessageFromChat(this.uuid);
      this.page = 0;
      this.chatService.activeChat$.subscribe(r => {
        this.resultData = [];
        this.activeChat = Object.assign(new Chat(), r);
        this.updatedChat = Object.assign(new Chat(), r);
        this.updatedChatName = this.activeChat.name;
      })
      this.chatService.activeChat$.next(Object.assign(new Chat(), this.chatService.chatList.find((c, i, arr) => {
        return c.uuid === params.uuid;
      })));
    });

  }

  ngOnDestroy(): void {
    this.chatApi.CloseConnection();
  }

  ngAfterViewChecked(): void {
    if (this.page === 0) {
      this.scrollToLast();
    }
  }

  scrollToLast() {
    // scroll to the last message
    this.chatWrapper.nativeElement.scrollTop = this.chatWrapper.nativeElement.scrollHeight;
  }

  listenToChat() {
    this.chatApi.listenToChat(this.uuid).pipe(
      takeUntil(this.destroyed$)
    ).subscribe(r => {
      if (r) {
        if (r.command === 'user_typing') {
          if (r.user !== this.authService.user.name) {
            this.isOtherTyping = r.isTyping;
          }
        } else {
          if (r.command === 'new_message') {
            this.messages.push(r.message);
          } else {
            this.messages.unshift(...r.messages.reverse());
          }
          new Set(this.messages.map(x => this.datePipe.transform(x.createdDate, 'EEEE, MMMM d'))).forEach((date) => {
            const dateIndex = this.resultData.findIndex(r => r.date === date);
            if (dateIndex > -1) {
              this.resultData[dateIndex].messages = this.messages.filter(i => this.datePipe.transform(i.createdDate, 'EEEE, MMMM d') === date);
            } else {
              this.resultData.push({
                date: date,
                messages: this.messages.filter(i => this.datePipe.transform(i.createdDate, 'EEEE, MMMM d') === date)
              })
            }
          })
        }
      }
    })
  }

  onTyping() {
    clearTimeout(this.timeout);
    if (!this.isTyping) {
      this.isTyping = this.messagetxt !== '';
      this.sendTyping();
    }
    if (this.messagetxt === '') {
      clearTimeout(this.timeout);
      this.isTyping = false;
      this.sendTyping();
      return;
    }
    this.timeout = setTimeout(() => {
      this.isTyping = false;
      this.sendTyping();
    }, 2000);
    this.page = 0;
    this.checkLanguage();
  }

  sendTyping() {
    const content = {
      command: 'user_typing',
      is_typing: this.isTyping
    }
    this.chatApi.sendTypingToChat(content);
  }

  checkLanguage() {
    this.isMessageArabic = /^[\u0600-\u06FF]{1,}/.test(this.messagetxt);
  }

  sendMessage() {
    const msg = {
      command: 'new_message',
      message: this.messagetxt,
      chatId: this.uuid,
      //TODO CHANGE THIS
      message_type: 1
    }
    this.chatApi.sendMessageToChat(msg);
    this.messagetxt = '';
    this.page = 0;
  }

  openGroupInfoModal() {
    this.groupInfoModalRef = this.modalService.open(this.groupInfoModal, {
      size: 'md',
      centered: true
    });
  }

  closeGroupInfoModal() {
    this.groupInfoModalRef.close();
  }

  chatScroll(e) {
    const chatListEle = this.chatWrapper.nativeElement;
    if (this.page === 0) {
      this.page++;
    } else if (this.chatWrapper.nativeElement.scrollTop === 0) {
      chatListEle.scrollTop = 1;
    } else if (
      chatListEle.scrollTop < 400 && this.page === this.messages.length / 20
    ) {
      this.page++;
      this.chatApi.fetchMessageFromChat(this.uuid, this.page);
    }

  }



  removeMember(m: User) {
    this.isMembersListUpdated = true;
    this.updatedChat.membersList = this.updatedChat.membersList.filter(member => member.id !== m.id);
  }

  updateChat() {
    this.spinner.show();
    this.updatedChat.members = this.updatedChat.membersList.map((val) => val.id);
    this.chatApi.updateChat(this.updatedChat).subscribe((c) => {
      this.activeChat = c;
      this.chatService.chats$.next(this.chatService.chatList.map((val) => {
        if (val.id === this.activeChat.id) {
          return this.activeChat;
        } else {
          return val;
        }
      }))
      this.spinner.hide();
      this.closeGroupInfoModal();
      this.toastr.success('Chat Info Updated', 'Success');
    }
    )
  }

  addChatMembers(dropdownRef: NgbDropdown) {
    this.updatedChat.membersList = this.updatedChat.membersList.concat(this.addedChatMembers);
    this.addedChatMembers = [];
    this.isMembersListUpdated = true;
    dropdownRef.close()

  }

  membersIncludes(m: User) {
    return this.updatedChat.membersList.find((val) => val.id === m.id);
  }

  isChatUpdated() {
    return this.activeChat.name !== this.updatedChat.name
      || this.isMembersListUpdated
  }

  isLoggedUser(id: number) {
    return this.authService.user.id === id;
  }
}